<template src='./tabTasks.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import { mapGetters } from 'vuex'
import moment from 'moment'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import TreeViewHistoric from '../../../treeViewHistoric/TreeviewHistoric'
import language from '../../../../../build/language/index.js'
import closeModal from '../../../../events/closeModal.js'
import { conciliationStatusTranslate, taskBondTypeTranslate, taskStatusesTranslate } from '../../../../utils/statusesTranslator.js'
import customValidator from '../../../../utils/customValidator.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import popExitingConfirmation from '../../../../utils/popExitingConfirmation'

moment.locale(language.getDatePickerLanguage())
moment.updateLocale(language.getDatePickerLanguage(), { invalidDate: ' - ' })

export default {
  name: 'TabTasks',

  components: {
    LoadingPlaceholder,
    TreeViewHistoric,
    vSelect,
    Datepicker,
    ButtonPrimary
  },

  data () {
    return {
      currentTask: {},
      alreadySaved: false,
      // lista para statuses de conciliação, para conclusão automática de tarefa
      concilStatusesBase: [],
      // lista para statuses de conciliação, para conclusão automática de tarefa
      concilStatuses: [],
      // asset de loading
      loadingGif: require('../../../../assets/loading-gif/loading.svg'),
      // root para colunas de datatables (histórico de tarefas do lançamento)
      columns: [],
      // root para opções de datatables (histórico de tarefas do lançamento)
      options: {
        filterable: false,
        perPage: 5,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: null
        },
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 }
      },
      invalid: false,
      // atributo de disable do datepicker
      toDate: new Date(),
      // atributo de disable do datepicker
      fromDate: new Date('December 31, 2999 23:59:59'),
      // elemento interno do datepicker
      inputDate: null,
      // lista com itens do histórico de tarefas
      taskHistory: [],
      // model para exibição da tarefa ativa
      activeTask: null,
      // model para cadastro de ocorrência/atualização de status de uma tarefa
      taskOcurrence: {
        situacao: {},
        observacaoHistorico: ''
      },
      // lista de operadores utilizada no cadastro/edição de tarefa
      operators: [],
      // Configuração do tooltip dos botões de expandir/recolher
      treeViewButtonTitle: {
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher')
      },
      // flag para form desabilitado, indicando modo de visualização de tarefa
      isVisualisingTask: false,
      // constrola o seletor de statuses para conciliação automática
      autoConcludeSelectedSize: 0,
      disabledBtnChangeStatusTask: true,
      erroDataDeVencimento: false,
      canEditTask: true,
      showActionButtons: true,
      defaultObject: null,
      tarefaStatuses: [],
      // flag para habilitar/desabilitar o botão de salvar
      disabledBtnSaveTask: false
    }
  },

  props: {
    // Prop enviada pelos relatórios de lançamentos.
    // Indica que as informações vêm dos movimentos bancários/financeiros.
    idMovimento: {
      type: String,
      default: null
    },

    // Prop enviada pelos relatórios de lançamentos.
    // Indica que as informações vêm dos movimentos bancários/financeiros.
    tipoMovimento: {
      type: String,
      default: null
    },

    // Prop enviada pelos relatórios de lançamentos.
    // Indica que as informações vêm dos movimentos bancários/financeiros.
    statusMovimento: {
      type: String,
      default: null
    },

    idTarefa: {
      type: String,
      default: null
    }
  },

  watch: {
    task: {
      handler () {
        if (this.defaultObject !== null && !this.alreadySaved) {
          this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.task))
        }
      },
      deep: true
    }
  },

  computed: {
    hintNoMovment () {
      return this.$t('consultaTarefa.labels.tarefaLancamentoRemovido')
    },

    statusesBase () {
      return [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto')
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado')
        },
        {
          id: 'M',
          nome: this.$t('statusConciliacao.conciliadoManualmente')
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente')
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel')
        }
      ]
    },
    // lista de tipos de vinculo para tarefa
    tarefaTipoVinculo () {
      return [
        {
          id: 'MF',
          nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoMF')
        },
        {
          id: 'CL',
          nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoCL')
        }
      ]
    },
    // retorna o nome do usuário logado
    loggedUser () {
      return this.$store.getters.user
    },
    // retorna o email do usuário logado
    loggedUserId () {
      return this.$store.getters.userId
    },
    // retorna o idioma para o datepicker
    datePickerLanguage () {
      return language.getDatePickerLanguageObject()
    },
    // retorna tradução da mensagem para envio automatico de email
    messageEmail () {
      return this.$t('tarefaEmMassa.titulos.enviarEmail')
    },
    // renderiza form para cadastro/edição de tarefa
    createEditTask () {
      return !this.isLoadingTaskData && this.isManagingTask
    },
    // renderiza tab quando não existir nenhuma tarefa para aquele lançamento
    noTasksBonded () {
      return !this.isLoadingTaskData && !this.hadTasksBonded && !this.isManagingTask
    },
    // renderiza tab quando houverem tarefas ativas ou não  para aquele lançamento
    withTaskBonded () {
      return !this.isLoadingTaskData && this.hadTasksBonded && !this.isManagingTask
    },
    // Define o "titulo" da área de detalhes da tarefa, variando caso haja tarefa ativa ou não.
    taskDetailsHeaderTitle () {
      return this.hasActiveTask
        ? this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoComTarefaAtiva')
        : this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoSemTarefaAtiva')
    },
    // Define o "titulo" do botão superior da área de detalhes da tarefa,
    // variando caso haja tarefa ativa ou não.
    taskDetailsHeaderButton () {
      return this.hasActiveTask
        ? this.$t('modalDetalhesLanc.tabTarefas.labels.detalheTarefa')
        : this.$t('modalDetalhesLanc.tabTarefas.labels.novaTarefa')
    },
    // Dica do botão de detalhes apresentado na datatable de histórico de tarefas do lançamento
    tipAcaoDetalhes () {
      return this.$t('modalDetalhesLanc.tabTarefas.labels.verDetalhe')
    },
    // flag para form desabilitado, indicando modo de visualização de tarefa
    canReopenTask () {
      return this.isVisualisingTask && !this.hasActiveTask
    },
    // flag para ação de auto atribuição de tarefa
    canAssignToTask () {
      return this.loggedUserId !== this.activeTask.responsavel.id
    },
    // flag para permissão de funcionalidade
    canPerformTaskAction () {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0
    },

    dueDateFormatted () {
      if (this.activeTask.dataVencimento && typeof this.activeTask.dataVencimento === 'number') {
        return moment(this.activeTask.dataVencimento).format('l')
      } else {
        return this.activeTask.dataVencimento
      }
    },

    hasUnsavedChanges () {
      return this.$store.getters.hasUnsavedChanges
    },

    task: {
      get () {
        return this.$store.getters.task
      },
      set (task) {
        return this.$store.dispatch('setTask', task)
      }
    },
    ...mapGetters([
      'hadTasksBonded',
      'isLoadingTaskData',
      'isManagingTask',
      'hasActiveTask'
    ])
  },

  mounted () {
    this.resetTaskStatuses()
    this.erroDataDeVencimento = false
    this.disabledBtnChangeStatusTask = true
    this.$store.dispatch('clearFlagsTasks')
    this.$nextTick(() => {
      this.$validator.reset()
    })
  },

  methods: {
    resetTaskStatuses (isCreatingTask) {
      this.tarefaStatuses = [
        {
          id: 0,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')
        },
        {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        {
          id: 20,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')
        }
      ]

      if (!isCreatingTask) {
        this.tarefaStatuses.push(
          {
            id: 90,
            nome: this.$t('tarefaEmMassa.tarefaStatuses.concluido')
          },
          {
            id: 99,
            nome: this.$t('tarefaEmMassa.tarefaStatuses.cancelada')
          }
        )
      }
    },

    // seta o objeto 'responsavel' que e usado na tarefa
    setResponsible (responsible) {
      return {
        id: responsible.id,
        nome: responsible.nome,
        senhaBloqueada: responsible.senhaBloqueada,
        numeroTentativa: responsible.numeroTentativa,
        idEntidade: responsible.idEntidade,
        nomeEntidade: responsible.nomeEntidade,
        name: responsible.name
      }
    },

    // seta o objeto 'historico' que e usado na tarefa
    setHistoric (historic) {
      return historic.map(history => {
        return {
          id: history.id,
          descricao: history.descricao,
          data: history.data,
          usuario: {
            nome: history.usuario ? history.usuario.nome : ' - '
          },
          situacao: history.situacao,
          idTransacao: history.idTransacao
        }
      })
    },

    // Ativa o botão caso a descrição não seja vazia
    onDescriptionChanged (ev) {
      ev.currentTarget.value !== '' || this.activeTask.situacao.id !== this.taskOcurrence.situacao.id
        ? this.disabledBtnChangeStatusTask = false
        : this.disabledBtnChangeStatusTask = true

      if (!this.taskOcurrence.situacao) this.disabledBtnChangeStatusTask = true
    },

    // Ativa o botão caso a situação seja diferente da atual situação da tarefa
    onSituationChanged (situation) {
      this.taskOcurrence.situacao = situation

      if (situation) {
        this.activeTask.situacao.id !== situation.id || this.taskOcurrence.observacaoHistorico !== ''
          ? this.disabledBtnChangeStatusTask = false
          : this.disabledBtnChangeStatusTask = true
      } else {
        this.disabledBtnChangeStatusTask = true
      }
    },

    // Função para fechamento da modal
    closeModal (idModal) {
      this.disabledBtnChangeStatusTask = true
      this.disabledBtnSaveTask = false
      this.$nextTick(() => {
        this.$validator.reset()
      })
      $('#' + idModal).modal('hide')
    },

    // Aciona flag de exibição do laoding
    startLoading () {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: true,
        hasBondedTask: false,
        managingTask: this.isManagingTask
      })
    },

    // Aciona flag de exibição para nenhuma tarefa existente
    noTaskExisting () {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: false,
        managingTask: this.isManagingTask
      })
    },

    // Aciona flag de exibição para lançamento com histórico de tarefas
    hasTaskHistory () {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: true,
        managingTask: this.isManagingTask
      })
    },

    // Aciona flag de exibição para criação/edição de tarefa
    managingTask () {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: this.hadTasksBonded,
        managingTask: true
      })

      this.preparteForm()
    },

    // Função para criar label para statuses de conclusão automática baseado no identificador de status
    concatStatusesAutoConcluede (conclusoesAutomaticas) {
      if (!conclusoesAutomaticas || conclusoesAutomaticas.length === 0) {
        return ' - '
      } else {
        let statuses = ''
        conclusoesAutomaticas.forEach(sigla => {
          statuses += conciliationStatusTranslate(sigla.situacaoConciliacao) + '|'
        })
        return statuses.substring(0, statuses.length - 1)
      }
    },

    // Função para carregar os detalhes da tarefa de um lançamento excluído
    loadTaskDetail () {
      this.isVisualisingTask = false
      this.startLoading()
      this.resetTaskData()
      this.resetActiveTaskData()
      this.initializeBaseConcilList()

      let self = this
      this.$store.dispatch('getTaskDetails', this.idTarefa)
        .then((response) => {
          let details = response.data
          this.setDetailTaskVisual(details, self)
        })
        .catch((error) => {
          self.$root.$refs.notification.error(error.message)
        })
    },

    // Função para carregar os dados iniciais das tarefas do lançamento selecionado.
    // Resultado dessa consulta define o estado de apresentação da aba.
    loadTaskData (clearTaskData) {
      this.startLoading()
      let param = {
        tipoVinculo: this.tipoMovimento === 'MovFin' ? 'MF' : 'CL',
        idVinculo: this.idMovimento
      }

      if (clearTaskData) {
        this.resetTaskData()
        this.resetActiveTaskData()
      }

      this.initializeBaseConcilList()
      let self = this
      this.$store.dispatch('loadTasksFromStatement', param).then((response) => {
        this.resetTaskStatuses()
        this.alreadySaved = false
        this.options.perPage = 10
        let responseHistory = []
        let taskResult = response.data.data
        if (!taskResult || taskResult.length === 0) { // Nenhuma tarefa associada
          self.noTaskExisting()
        } else {
          taskResult.forEach(task => {
            if (task.tarefa.situacao === 90 || task.tarefa.situacao === 99) { // Tarefa concluída ou cancelada
              responseHistory.push(task.tarefa)
            } else { // Tarefa ativa
              self.activeTask = {
                id: task.tarefa.id,
                nome: task.tarefa.nome,
                tipoVinculo: {
                  id: task.tarefa.tipoVinculo,
                  nome: taskBondTypeTranslate(task.tarefa.tipoVinculo)
                },
                responsavel: {
                  id: task.tarefa.usuarioResponsavel.idUsuario,
                  nome: task.tarefa.usuarioResponsavel.nome
                },
                situacao: {
                  id: task.tarefa.situacao
                },
                dataAlteracao: task.tarefa.dataAlteracao,
                dataVencimento: task.tarefa.dataVencimento ? task.tarefa.dataVencimento : ' - ',
                descricao: task.tarefa.descricao,
                historico: this.setHistoric(task.tarefa.historico),
                situacoesConclusaoAutomatica: task.tarefa.conclusoesAutomaticas,
                conclusoesAutomaticas: task.tarefa.conclusoesAutomaticas
                  ? this.concatStatusesAutoConcluede(task.tarefa.conclusoesAutomaticas)
                  : ' - '
              }
              self.taskOcurrence.situacao.id = task.tarefa.situacao
              self.taskOcurrence.situacao.nome = taskStatusesTranslate(task.tarefa.situacao)
              this.options.perPage = 5
              this.$store.dispatch('setHasActiveTask', true)
            }
          })
          self.hasTaskHistory()
          self.prepareTaskHistoryList(responseHistory)
        }
        this.disabledBtnChangeStatusTask = true
      }).catch((error) => {
        this.$root.$refs.notification.error(error)
        this.closeModal()
      })
    },

    setDetailTaskVisual (details, self) {
      this.showActionButtons = false
      self.task = {}
      self.task.id = details.id
      self.task.nome = details.nome
      self.task.descricao = details.descricao
      self.task.dataAlteracao = details.dataAlteracao
      self.task.dataVencimento = details.dataVencimento ? moment(details.dataVencimento) : null
      self.task.tipoVinculo = {
        id: details.tipoVinculo,
        nome: taskBondTypeTranslate(details.tipoVinculo)
      }
      self.task.situacao = {
        id: details.situacao,
        nome: taskStatusesTranslate(details.situacao)
      }
      if (details.usuarioResponsavel) {
        self.task.responsavel = {
          id: details.usuarioResponsavel.idUsuario,
          nome: details.usuarioResponsavel.nome
        }
      }
      self.task.conclusaoAutomatica = []
      if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {
        details.conclusoesAutomaticas.forEach(status => {
          self.task.conclusaoAutomatica.push({
            id: status.situacaoConciliacao,
            nome: conciliationStatusTranslate(status.situacaoConciliacao)
          })
        })
        self.task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas)
      } else {
        self.task.conclusoesAutomaticas = ' - '
      }
      self.task.historico = details.historico
      self.isVisualisingTask = true
      self.managingTask()
    },

    // Restaura o estado orginal (vazio) do objeto de bind para nova tarefa
    resetTaskData () {
      this.erroDataDeVencimento = false

      this.$store.dispatch('setEmptyTask')
      this.$store.dispatch('setTask', {
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        }
      })

      let tipoVinculo = {}

      if (this.tipoMovimento === 'MovBan') {
        tipoVinculo = {
          id: 'CL',
          nome: this.$t('tarefaEmMassa.labels.tipoCl')
        }
      } else {
        tipoVinculo = {
          id: 'MF',
          nome: this.$t('tarefaEmMassa.labels.tipoMf')
        }
      }

      this.$store.dispatch('setTask', { tipoVinculo })
      this.currentTask = this.task

      this.autoConcludeSelectedSize = 0
      this.concilStatuses = this.concilStatusesBase.slice()
    },

    // Restaura o estado orginal (vazio) do objeto de bind para tarefa ativa
    resetActiveTaskData () {
      this.$store.dispatch('setHasActiveTask', false)
      this.activeTask = null
      this.defaultObject = null
    },

    // Define listeners para datepicker da tela de cadastro/edição de tarefa
    preparteForm () {
      // delay de renderizacao da DOM alterada
      setTimeout(() => {
        this.inputDate = document.getElementById('dataVencimento')
        if (this.inputDate) {
          this.inputDate.setAttribute('autocomplete', 'off')
          this.inputDate.addEventListener('blur', () => {
            Promise.resolve(this.validateDate())
          })
        }
      }, 100)
    },

    // Incializa lista de operadores da tela de cadastro/edição de tarefa e
    // aciona renderização do form.
    loadOperators () {
      this.$store.dispatch('getOperatorsWithTaskPermission')
        .then(activeOperators => {
          this.operators = activeOperators

          let idUsuario = this.task.responsavel ? this.task.responsavel.id : this.loggedUserId
          this.operators.forEach(op => {
            if (op.id === idUsuario) {
              this.task.responsavel = this.setResponsible(op)
            }
          })
          if (!this.task.responsavel) {
            this.task.responsavel = this.operators[0]
          }
          this.defaultObject = { ...this.task }
          this.defaultObject.responsavel = this.setResponsible(this.task.responsavel)
          this.managingTask()
        })
    },

    // validação global do datepicker
    validateDate () {
      return new Promise((resolve) => {
        let isValid = this.inputDate.value.length === 10 &&
          customValidator.isValidDate(this.inputDate.value)
        if (!isValid) {
          this.task.dataVencimento = null
          this.$refs.dataVencimento.$children
            .find(item => !!item.id).typedDate = ''
        }
        resolve()
      })
    },

    dataDeVencimentoValida () {
      if (this.task.dataVencimento) {
        let today = new Date()
        let yesterday = today.setDate(today.getDate() - 1)
        let validDate = false

        validDate = this.task.dataVencimento.getTime() > yesterday

        this.erroDataDeVencimento = !validDate

        return validDate
      }

      return true
    },

    // Valida o form de cadastro/edição de tarefa (obrigatoriedades).
    // Aciona serviço de persistência caso form seja válido.
    validate () {
      let previousDate
      let newDate = new Date(this.task.dataVencimento).getTime()

      this.activeTask ? previousDate = new Date(this.activeTask.dataVencimento).getTime() : previousDate = false

      let self = this

      this.$validator.validateAll()
        .then(result => {
          if ((result && this.activeTask !== null && previousDate === newDate) ||
            result && this.dataDeVencimentoValida() ||
            result && this.task.dataVencimento === null) {
            self.salvarTarefa()
            this.alreadySaved = true
            self.$nextTick(() => {
              self.$validator.reset()
            })
          } else if (previousDate !== newDate && !self.dataDeVencimentoValida()) {
            self.task.dataVencimento === null ? self.erroDataDeVencimento = false : self.erroDataDeVencimento = true
          }
        })
    },

    // Constróio objeto para nova tarefa e aciona requisição para persistência.
    salvarTarefa () {
      this.disabledBtnSaveTask = true

      let newTask = {
        id: this.task.id,
        dataCriacao: new Date(),
        dataVencimento: this.task.dataVencimento,
        nome: this.task.nome,
        descricao: this.task.descricao,
        tipoVinculo: this.task.tipoVinculo.id,
        situacao: this.task.situacao.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.task.dataAlteracao,
        usuarioResponsavel: {
          idUsuario: this.task.responsavel.id
        },
        enviarEmail: this.task.enviarEmail,
        situacoesConclusaoAutomatica: []
      }

      this.task.conclusaoAutomatica.forEach(status => {
        newTask.situacoesConclusaoAutomatica.push(status.id)
      })

      this.$store.dispatch('createNewTask', newTask)
        .then((response) => {
          this.$root.$refs.notification.success(response.data.message)
          this.resetTaskData()
          this.task && this.task.id ? this.viewOldTask(this.task, true) : this.loadTaskData()
          this.$store.dispatch('setIsManagingTask', false)
          closeModal.$emit('taskChange', true)
          this.$store.dispatch('setHasUnsavedChanges', false)
          this.$nextTick(() => {
            this.$validator.reset()
          })
          this.disabledBtnSaveTask = false
        })
        .catch((error) => {
          this.disabledBtnSaveTask = false
          this.$root.$refs.notification.error(error.message)
        })
    },

    // Monta configuração para dataTable de histórico de tarefas do lançamento.
    mountTaskHistoryDataTable () {
      this.columns = [
        'acoes',
        'nome',
        'descricao',
        'tipoVinculo',
        'responsavel',
        'data'
      ]

      this.options.headings = {
        acoes: '',
        nome: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'),
        descricao: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'),
        tipoVinculo: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'),
        responsavel: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'),
        data: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData')
      }

      this.options.columnsClasses = {
        acoes: 'col-1',
        nome: 'col-1 limit-char',
        descricao: 'col-1 limit-char',
        tipoVinculo: 'col-1 limit-char',
        responsavel: 'col-1 limit-char',
        data: 'col-1 limit-char'
      }
      this.sortable = ['nome', 'descricao', 'tipoVinculo', 'responsavel', 'data']
      this.options.orderBy = 'nome'
    },

    // Monta lista de histórico de tarefas para exibição na dataTable
    prepareTaskHistoryList (responseHistory) {
      this.taskHistory = []
      if (responseHistory && responseHistory.length > 0) {
        responseHistory.forEach(item => {
          this.taskHistory.push({
            id: item.id,
            nome: item.nome,
            descricao: item.descricao,
            tipoVinculo: item.tipoVinculo === 'MF' ? this.tarefaTipoVinculo[0].nome : this.tarefaTipoVinculo[1].nome,
            responsavel: item.usuarioResponsavel ? item.usuarioResponsavel.nome : ' - ',
            data: item.dataVencimento ? moment(item.dataVencimento).format('l') : ' - '
          })
        })
      }
      this.mountTaskHistoryDataTable()
    },

    // Salva nova ocorrência/status para a tarefa atual
    updateTaskStatus () {
      this.disabledBtnChangeStatusTask = true

      let taskOcur = {
        id: this.activeTask.id,
        tipoVinculo: this.activeTask.tipoVinculo.id,
        situacao: this.taskOcurrence.situacao.id,
        observacaoHistorico: this.taskOcurrence.observacaoHistorico,
        idVinculo: this.idMovimento,
        dataAlteracao: this.activeTask.dataAlteracao
      }

      this.$store.dispatch('saveTaskOcurrence', taskOcur)
        .then((response) => {
          this.resetActiveTaskData()
          this.loadTaskData()
          this.taskOcurrence = {
            situacao: {},
            observacaoHistorico: ''
          }
          this.$root.$refs.notification.success(response.data.message)
          closeModal.$emit('taskChange', true)
          this.$nextTick(() => {
            this.$validator.reset()
          })
        })
        .catch((error) => {
          this.disabledBtnChangeStatusTask = false
          this.$root.$refs.notification.error(error.message)
        })
    },

    // Inicia fluxo de criação/edição de tarefa, baseado no estado da flag hasActiveTask:
    // TRUE -> Edição da tarefa activeTask
    // FALSE -> Criação de nova tarefa para o lançamento
    manageTask () {
      this.erroDataDeVencimento = false

      // Prepara model de criação/edição
      this.resetTaskData()
      this.isVisualisingTask = false
      if (this.hasActiveTask) {
        const task = {
          id: this.activeTask.id,
          nome: this.activeTask.nome,
          tipoVinculo: this.activeTask.tipoVinculo,
          descricao: this.activeTask.descricao,
          situacao: {
            id: this.activeTask.situacao.id,
            nome: this.activeTask.situacao.nome ? this.activeTask.situacao.nome : taskStatusesTranslate(this.activeTask.situacao.id)
          },
          dataAlteracao: this.activeTask.dataAlteracao,
          dataVencimento: this.activeTask.dataVencimento && this.activeTask.dataVencimento !== ' - ' ? new Date(this.activeTask.dataVencimento) : null,
          responsavel: this.activeTask.responsavel,
          conclusaoAutomatica: [],
          enviarEmail: false
        }
        this.autoConcludeSelectedSize = this.activeTask.situacoesConclusaoAutomatica ? this.activeTask.situacoesConclusaoAutomatica.length : (this.activeTask.conclusaoAutomatica ? this.activeTask.conclusaoAutomatica.length : 0)
        if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {
          this.activeTask.situacoesConclusaoAutomatica.forEach(status => {
            task.conclusaoAutomatica.push({
              id: status.situacaoConciliacao,
              nome: conciliationStatusTranslate(status.situacaoConciliacao)
            })
          })
        } else if (this.activeTask.conclusaoAutomatica && this.activeTask.conclusaoAutomatica.length > 0) {
          this.activeTask.conclusaoAutomatica.forEach(status => {
            task.conclusaoAutomatica.push({
              id: status.id,
              nome: conciliationStatusTranslate(status.nome)
            })
          })
        }
        this.changeAutoConcludeList(this.task.conclusaoAutomatica)
        if (this.activeTask.historico && this.activeTask.historico.length > 0) {
          task.historico = this.activeTask.historico.slice()
        }
        this.$store.dispatch('setTask', task)
      }
      // Inicia loading de requisição
      this.startLoading()
      // Carrega lista de operadores (internamente inicializa o form)
      this.loadOperators()
    },

    // Cancela o cadastro/edição de tarefa, retornando para a visualização adequada da modal
    // através do reload da mesma (devido à volatilidade dos dados da tarefa, dada a possibilidade de
    // alteração em multiplas sessões)/
    cancelManagement () {
      this.loadTaskData(true)
      this.$store.dispatch('setIsManagingTask', false)
    },

    goBack () {
      if (this.hasUnsavedChanges && !popExitingConfirmation()) {
        return
      }
      this.$store.dispatch('setHasUnsavedChanges', false)
      this.viewOldTask()
    },

    // Consulta detalhes de uma determinada tarefa e monta form de edição (desabilitado) para
    // visualização dos dados.
    viewOldTask (oldTask, isEdit) {
      if (isEdit) {
        this.canEditTask = true
      } else {
        if (oldTask) {
          this.canEditTask = false
        } else {
          this.canEditTask = true
        }
      }
      let self = this
      if (oldTask || self.activeTask) {
        this.$store.dispatch('getTaskDetails', oldTask ? oldTask.id : self.activeTask.id)
          .then((response) => {
            let details = response.data
            const task = {}
            task.id = details.id
            task.nome = details.nome
            task.tipoVinculo = {
              id: details.tipoVinculo,
              nome: taskBondTypeTranslate(details.tipoVinculo)
            }
            task.descricao = details.descricao
            task.situacao = {
              id: details.situacao,
              nome: taskStatusesTranslate(details.situacao)
            }
            task.dataAlteracao = details.dataAlteracao
            task.dataVencimento = details.dataVencimento ? moment(details.dataVencimento) : null
            if (details.usuarioResponsavel) {
              task.responsavel = this.setResponsible(details.usuarioResponsavel)
            }
            task.conclusaoAutomatica = []
            if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {
              details.conclusoesAutomaticas.forEach(status => {
                task.conclusaoAutomatica.push({
                  id: status.situacaoConciliacao,
                  nome: conciliationStatusTranslate(status.situacaoConciliacao)
                })
              })
              task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas)
            } else {
              task.conclusoesAutomaticas = ' - '
            }
            task.historico = this.setHistoric(details.historico)
            self.isVisualisingTask = true
            if (isEdit) {
              self.activeTask = task
            }
            self.$store.dispatch('setTask', task)
            self.currentTask = task
            self.managingTask()
          })
          .catch((error) => {
            self.$root.$refs.notification.error(error.message)
          })
      } else {
        self.isVisualisingTask = false
        this.resetTaskData()
        self.managingTask()
        self.resetTaskStatuses(true)
        self.loadOperators()
      }
    },

    // Reabre uma tarefa do histórico.
    reopenTask () {
      let task = {
        id: this.task.id,
        tipoVinculo: this.task.tipoVinculo.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.task.dataAlteracao
      }

      this.$store.dispatch('reopenTask', task)
        .then((response) => {
          this.isVisualisingTask = false
          this.loadTaskData()
          this.viewOldTask(this.task, true)
          this.$root.$refs.notification.success(response.data.message)
          closeModal.$emit('taskChange', true)
          this.$nextTick(() => {
            this.$validator.reset()
          })
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    // Retorna data formatada
    formatDate (date) {
      return moment(date).format('l')
    },

    // Colocar o usuário logado como responsável pela tarefa.
    assignTaskToLoggedUser () {
      let task = {
        id: this.activeTask.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.activeTask.dataAlteracao,
        usuarioResponsavel: {
          idUsuario: this.loggedUserId
        },
        situacoesConclusaoAutomatica: []
      }
      if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {
        this.activeTask.situacoesConclusaoAutomatica.forEach(status => {
          task.situacoesConclusaoAutomatica.push(status.situacaoConciliacao)
        })
      }
      this.$store.dispatch('assignTaskToLoggedUser', task)
        .then((response) => {
          this.loadTaskData()
          this.$root.$refs.notification.success(response.data.message)
          closeModal.$emit('taskChange', true)
          this.$nextTick(() => {
            this.$validator.reset()
          })
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    // Limpa dados de tarefa ativa e model de cadastro para exibição do form de cadastro "em branco".
    startTask () {
      this.resetActiveTaskData()
      this.resetTaskStatuses(true)
      this.manageTask()
    },

    // Atualiza listagem da combo de conclusão automática baseada nos valores já selecionados
    changeAutoConcludeList (selectDataTableDinamicColumn) {
      if (this.autoConcludeSelectedSize > 0 &&
          selectDataTableDinamicColumn &&
          (this.autoConcludeSelectedSize <= selectDataTableDinamicColumn.length)) {
        // Adicionando
        let selected = selectDataTableDinamicColumn[selectDataTableDinamicColumn.length - 1]
        // remove item da combo
        this.concilStatuses = _.without(this.concilStatuses, selected)
        // Incrementa a variável de controle
        this.autoConcludeSelectedSize++
      } else {
        // Removendo
        this.concilStatuses = this.concilStatusesBase.slice()
        selectDataTableDinamicColumn.forEach(item => {
          let index = this.concilStatuses.findIndex(dinamicColumn => dinamicColumn.id === item.id)
          this.concilStatuses.splice(index, 1)
        })
        // Decrementa a variável de controle
        this.autoConcludeSelectedSize--
      }
      this.setTask('conclusaoAutomatica', selectDataTableDinamicColumn)
    },

    // Remove status do lançamento das possibilidades de seleção para conclusão automática.
    initializeBaseConcilList () {
      if (this.statusMovimento) {
        let index = this.statusesBase.findIndex(dinamicColumn => dinamicColumn.id === this.statusMovimento)
        let status = this.statusesBase[index]
        this.concilStatusesBase = _.without(this.statusesBase, status)
      }
    },

    setTask (prop, value) {
      this.currentTask[prop] = value
      this.$store.dispatch('setTask', { [prop]: value })
    },

    selectSituacao (newSituacao) {
      this.setTask('situacao', newSituacao)
    },

    clearManagementTask () {
      this.$store.dispatch('clearFlagsTasks')
      this.resetTaskData()
    }
  }
}
</script>

<style>
@media screen and (min-width: 1199px) {
  .left-vertical-tabs {
    width: 10%;
  }

  .right-text-tabs {
    width: 90%;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .left-vertical-tabs {
    width: 15%;
  }

  .right-text-tabs {
    width: 85%;
  }
}

@media screen and (max-width: 991px) and (min-width: 560px) {
  .left-vertical-tabs {
    width: 20%;
  }

  .right-text-tabs {
    width: 80%;
  }
}

@media screen and (max-width: 559px) {
  .left-vertical-tabs {
    width: 25%;
  }

  .right-text-tabs {
    width: 75%;
  }
}

.left-vertical-tabs {
  border-bottom-left-radius: 3px;
}

.right-text-tabs {
  border-bottom-right-radius: 3px;
}

#btnTabLoteConcManualDivergence {
  margin-bottom: 10px;
  margin-top: 0px;
  min-width: auto;
  width: 26px;
  height: 26px;
  padding: 0px 0px 0px 1px;
}

#tab-allotment-id {
  margin: 0px;
  overflow: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
}

.loadingData {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  cursor: wait;
  height: 390px;
  background-size: 100px;
}

.limit-char {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.no-allotment-img {
  height: 30vh;
}

.big-txt-allotment {
  font-family: 'Inter', sans-serif !important;
font-weight: 700;
  color: #012351;
  font-size: 21px;
  margin: 1.5vh auto;
}

.grid-modal-content {
  padding: 5px 10px 0px 10px;
  min-height: 47vh;
  min-width: 47vw;
}

.detail-value-allotment {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #012351;
  font-size: 18px;
}

.detail-status-allotment {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 26px;
}

.detail-title-allotment {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  margin-top: 1vh;
  color: #012351;
}

#tab-allotment-id.modal-footer {
  padding: 0px;
}

#main-tasks-container.main-container {
  max-height: 50vh;
  overflow: auto;
}

#create-edit-task-form {
  max-height: 82vh;
  height: 100%;
  overflow: auto;
  padding-top: 10px;
}

.position-initial, .vdp-datepicker {
  position: initial;
}

.allotment-data-table {
  max-width: 100%;
  max-height: 40vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.font-C {
  color: #3bb57a !important;
}

.font-D {
  color: #f55753 !important;
}

.font-N {
  color: #56a9c1 !important;
}

.font-A {
  color: #fdbd39 !important;
}

.font-default {
  color: #17375f !important;
}

.col-1 {
  width: 3vw;
  font-size: 12px;
}

.col-2 {
  width: 7vw;
  font-size: 12px;
}

.selected-row {
  background-color: #617a95 !important;
  color: #fff;
}

.margin-container {
  margin-top: 15px;
}

.monetary-container {
  background: #eff0f3;
  border: 1px solid #DDD;
  border-bottom-right-radius: 3px;
  margin-top: 15px;
  padding: 15px;
  z-index: 3;
}

.loading-center {
  text-align: center;
  margin-bottom: 60px;
}

.detail-allotment-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #012351;
  font-size: 14px;
}

.VueTables__sortable>span.VueTables__heading {
  padding-right: 15px;
}

.VueTables__table .VueTables__sort-icon.glyphicon::before {
  top: 1px;
  position: absolute;
  left: -10px;
}

.table-icon {
  font-size: 14px;
}

.task-subtitle {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #fff;
  color: #626262;
  padding: 10px 0px 0px 15px;
  font-size: 18px;
}

/*Estilo da div do fundo do componente*/

.historicoTarefaFundo {
  max-height: 21vh;
  height: auto;
  overflow-x: auto;
  padding: 20px 0px 0px 0px;
  background-color: #EBF6F8;
  border-radius: 10px;
  margin: 0 10px;
}

.enviar-e-mail-automa {
  font-size: 11px !important;
  text-align: left;
  color: #2a2a2a;
  text-transform: initial !important;
}

.input-date-picker {
  border: none;
  width: 80%;
}

.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: not-allowed;
  font-weight: bold;
  color: #626262;
}

#btnSalvarOcorrenciaTarefa {
  right: 4px;
  height: 34px;
}

#btnSalvarOcorrenciaTarefa:disabled {
  opacity: 1;
}

.warning-area {
  background-color: #fff2cb;
  border: 1px solid #ffe599;
  border-radius: 4px;
  margin-bottom: 0.8vh;
}

.warning-text {
  color: #8e6f12 !important;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// TabTasks.vue?291becc8